// http://stackoverflow.com/questions/6248666/how-to-generate-short-uid-like-ax4j9z-in-js#answer-6248722
export function generateUID() {
    // I generate the UID from two parts here 
    // to ensure the random number provide enough bits.
    var firstPart = (Math.random() * 46656) | 0;
    var secondPart = (Math.random() * 46656) | 0;
    firstPart = ("000" + firstPart.toString(36)).slice(-3);
    secondPart = ("000" + secondPart.toString(36)).slice(-3);
    return firstPart + secondPart;
}

// converts query selector node object to an array
// var itemsQuery = document.querySelector('.item'); 
// var items = util.queryToArray(itemsQuery);
export function querytoArray(obj) {
  var array = [];
  // iterate backwards ensuring that length is an UInt32
  for (var i = obj.length >>> 0; i--;) { 
    array[i] = obj[i];
  }
  return array;
}

// finds current path based on siteConfig and current routeObject
export function findThePath(allRoutes, thePathObj) {
  // console.log('==============');
  // console.log('current route = ', thePathObj.path);
  let routeFound;

  for (let i = 0; i < allRoutes.length; i++) {
    let currentRoute = allRoutes[i];
    
    // if the route exists in the string at all
    if (currentRoute && thePathObj.path.indexOf(currentRoute.path) !== -1) {

      // if route is exact
      if (currentRoute.path === thePathObj.path) {
        // console.log(currentRoute.path === thePathObj.path);
        routeFound = currentRoute;
        i = allRoutes.length+1;

        // else if route has children and one match

      } else if (Array.isArray(currentRoute.content)) {
        // console.log('child content is array', currentRoute.content);
        for (let ii = 0; ii < currentRoute.content.length; ii++) {
          let currentSubRoute = currentRoute.content[ii];
        
          if (currentSubRoute.path === thePathObj.path) {
            routeFound = currentSubRoute;
            i = allRoutes.length+1;
            ii = currentRoute.content.length+1;
          }
        }
      }
    }
  }

  return routeFound;
}

// https://stackoverflow.com/questions/19491336/get-url-parameter-jquery-or-how-to-get-query-string-values-in-js#answer-21903119
export function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};


export function flattenMultiArray(array, mutable) {
  var nodes = (mutable && array) || array.slice(); // return a new array.
  var flattened = [];

  for (var node = nodes.shift(); node !== undefined; node = nodes.shift()) {
    if (Array.isArray(node)) {
      nodes.unshift.apply(nodes, node);
    } else {
      flattened.push(node);
    }
  }

  return flattened;
}


// WEBPACK FOOTER //
// ./src/scripts/_util.js